import { createSelector } from '@reduxjs/toolkit';
import getIn from 'transmute/getIn';
import { getWelcomeMessage } from './getWelcomeMessage';
export const getSpotlightPosition = createSelector(getWelcomeMessage, message => getIn(['spotlightConfig', 'position'], message));